import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import WindowsFactory from "./assets/windows/WindowsFactory";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
            <WindowsFactory />
            <ToastContainer
                position="top-right"
                theme="colored"
            />
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
